import { Trans, useTranslation } from 'react-i18next';
import { match } from 'ts-pattern';
import { PromoCard } from '../PromoCard';

type DisclaimerProps = {
  email?: string;
  typeOfLiability?: string | null;
  imagePath?: string;
};

export function Disclaimer({
  typeOfLiability,
  email = 'kunde@kommunekredit.dk',
  imagePath = '/calculator_blue.svg',
}: DisclaimerProps) {
  const { t } = useTranslation('ui');

  const href = typeOfLiability
    ? match(typeOfLiability.toLowerCase())
        .with(
          'i',
          () =>
            'https://www.kommunekredit.dk/laan/saadan-faar-i-et-laan/proces-for-kommunale-interessentskaber/',
        )
        .with(
          'k',
          () =>
            'https://www.kommunekredit.dk/laan/saadan-faar-i-et-laan/proces-for-kommuner-og-regioner/',
        )
        .with(
          'g',
          () =>
            'https://www.kommunekredit.dk/laan/saadan-faar-i-et-laan/proces-for-foreninger-og-selskaber/',
        )
        .otherwise(
          () => 'https://www.kommunekredit.dk/laan/saadan-faar-i-et-laan/',
        )
    : 'https://www.kommunekredit.dk/laan/saadan-faar-i-et-laan/';

  return (
    <PromoCard
      className=""
      description={
        <Trans
          i18nKey="calculator.disclaimer.description"
          ns="ui"
          values={{ email }}
          components={{
            1: (
              <a href={`mailto:${email}`} className="text-blue-60 underline">
                {email}
              </a>
            ),
          }}
        />
      }
      title={t('calculator.disclaimer.title')}
      image={
        <img
          className="h-18"
          src={imagePath}
          alt="calculator"
          loading="lazy"
          decoding="async"
        />
      }
      links={
        href
          ? [
              {
                href: href,
                label: t('calculator.disclaimer.linkLabel'),
                target: '_blank',
                icon: 'link-external',
                rightAligned: true,
                className: 'flex w-fit p-0 font-normal text-sm',
              },
            ]
          : undefined
      }
    />
  );
}
